import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchType } from '#/modules/search/types/SearchType';

export function getPopularSearchesBySearchType(
  i18n: I18nFn,
  searchType: SearchType,
) {
  switch (searchType) {
    case 'JOB':
      return [
        i18n('Communications'),
        i18n('Education'),
        i18n('Marketing'),
        i18n('Executive Director'),
        i18n('Attorney'),
      ];

    case 'INTERNSHIP':
      return [
        i18n('Psychology'),
        i18n('Law'),
        i18n('Legal'),
        i18n('Summer'),
        i18n('Policy'),
      ];

    case 'VOLOP':
      return [
        i18n('Board member'),
        i18n('Data analyst'),
        i18n('Research'),
        i18n('Health'),
        i18n('Art'),
      ];

    case 'EVENT':
      // TODO: add popular event search
      return [];

    case 'ORG':
      return [
        i18n('Education'),
        i18n('Human Rights'),
        i18n('Mental Health'),
        i18n('Immigration'),
        i18n('Health'),
      ];
  }
}
